import { Link } from 'react-router-dom';
import { CONTACT_EMAIL, SITE_NAME, SITE_TAGLINE } from '@/lib/site';
import NewsletterForm from './NewsletterForm';

const categoryLinks = [
  { id: 'hot', label: '热点突发' },
  { id: 'ent', label: '娱乐圈' },
  { id: 'society', label: '社会万象' },
  { id: 'tech', label: '科技前沿' },
  { id: 'life', label: '生活趣闻' },
  { id: 'talk', label: '影视解说' },
];

const aboutLinks = [
  { label: '关于我们', to: '/about' },
  { label: '品牌介绍', to: '/about#intro' },
  { label: '内容原则', to: '/about#principles' },
  { label: '用户口碑', to: '/about#reviews' },
];

const SiteFooter = () => (
  <footer className="mt-20 bg-secondary-950 text-background-100">
    <div className="mx-auto w-full max-w-shell px-4 py-14 md:px-8 md:py-16">
      <div className="grid gap-10 lg:grid-cols-12 lg:gap-8">
        <div className="lg:col-span-4">
          <Link to="/" className="flex items-center gap-2.5" aria-label={`${SITE_NAME}首页`}>
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-play-circle-fill text-xl" />
            </span>
            <span className="font-heading text-lg font-semibold tracking-tight text-background-50">
              {SITE_NAME}
            </span>
          </Link>
          <p className="mt-4 max-w-xs text-xs leading-relaxed text-secondary-200 md:text-sm">
            {SITE_TAGLINE}。聚合全网热门现场与话题解析，用最顺畅的播放体验，把当下最热的内容一次看完。
          </p>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="mt-4 inline-flex items-center gap-2 text-xs text-secondary-200 transition-colors hover:text-accent-300 md:text-sm"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-mail-line text-sm" />
            </span>
            {CONTACT_EMAIL}
          </a>
          <div className="mt-5 flex items-center gap-2">
            {['ri-weibo-line', 'ri-wechat-line', 'ri-bilibili-line', 'ri-youtube-line'].map((icon) => (
              <a
                key={icon}
                href="/about#contact"
                aria-label="社交媒体"
                className="flex h-9 w-9 items-center justify-center rounded-md border border-secondary-800 text-secondary-200 transition-colors hover:border-accent-400 hover:text-accent-300"
              >
                <i className={`${icon} text-base`} />
              </a>
            ))}
          </div>
        </div>

        <div className="lg:col-span-2">
          <h3 className="text-sm font-label font-medium text-background-50">内容分类</h3>
          <ul className="mt-4 flex flex-col gap-2.5">
            {categoryLinks.map((item) => (
              <li key={item.id}>
                <Link
                  to={`/category?category=${item.id}`}
                  className="text-xs text-secondary-200 transition-colors hover:text-accent-300 md:text-sm"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <h3 className="text-sm font-label font-medium text-background-50">关于本站</h3>
          <ul className="mt-4 flex flex-col gap-2.5">
            {aboutLinks.map((item) => (
              <li key={item.label}>
                <Link
                  to={item.to}
                  className="text-xs text-secondary-200 transition-colors hover:text-accent-300 md:text-sm"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <NewsletterForm />
        </div>
      </div>

      <div className="mt-12 flex flex-col gap-4 border-t border-secondary-800 pt-6 text-[11px] text-secondary-300 md:flex-row md:items-center md:justify-between md:text-xs">
        <p>© 2026 {SITE_NAME}. 保留所有权利。</p>
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
          <Link to="/about#principles" className="transition-colors hover:text-accent-300">
            内容原则
          </Link>
          <Link to="/about#contact" className="transition-colors hover:text-accent-300">
            联系我们
          </Link>
          <Link to="/category" className="transition-colors hover:text-accent-300">
            全部内容
          </Link>
        </div>
      </div>
    </div>
  </footer>
);

export default SiteFooter;